import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJobPaymentEmailTemplate.Save.IRequest;
type Response = Api.Core.ClaimJobPaymentEmailTemplate.Save.IResponse;
type Headers = Api.Core.ClaimJobPaymentEmailTemplate.Save.IHeaders;
const url = '/api/Management/ClaimJobPaymentEmailTemplate';
export default async function claimJobPaymentEmailTemplateSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
